import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'ui';

function ActivityProgress({ completed, total, ...props }) {
  const { t } = useTranslation();
  const safeCompleted = Math.max(0, completed);
  const safeTotal = Math.max(1, total);
  const progressPercentage = total === 0 ? 0 : Math.min(100, Math.max(0, (safeCompleted / safeTotal) * 100));
  const activitiesLabel = t('grades:x of y activities', { x: safeCompleted, y: safeTotal });

  return (
    <div className="activity-progress" {...props}>
      <div className="activity-progress__bar">
        <ProgressBar hasPercentageLabel={false} isLabelHidden label={activitiesLabel} progress={progressPercentage} />
      </div>
      <span className="activity-progress__text" aria-hidden="true">
        {activitiesLabel}
      </span>
    </div>
  );
}

ActivityProgress.propTypes = {
  completed: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default ActivityProgress;
